var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('div',{staticClass:"alert alert-danger text-center"},[_c('b',[_vm._v(_vm._s(_vm.$t('roles.permissions.org.authorization.warning')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }